import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getFirstDayOfCurrentMonth, getLastDayOfCurrentMonth } from '../../../utils/util';

import { requestRetrieveUserMetrics, requestDownloadUserMertics } from '../../../api/report/report.actions';

import UserMetrics from '../../../components/screens/reports/user-metrics/UserMetrics';

const UserMetricsContainer = () => {
  const userMetrics = useSelector((state) => state.report.userMetrics);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      requestRetrieveUserMetrics({
        dates: {
          fromDate: getFirstDayOfCurrentMonth(),
          toDate: getLastDayOfCurrentMonth(),
        },
      })
    );
  }, [dispatch]);

  const retrieveUserMetrics = (fromDate, toDate) => {
    dispatch(
      requestRetrieveUserMetrics({
        dates: { fromDate, toDate },
      })
    );
  };

  const downloadExcel = (fromDate, toDate) => {
    dispatch(
      requestDownloadUserMertics({
        dates: { fromDate, toDate },
      })
    );
  };

  return (
    <UserMetrics userMetrics={userMetrics} retrieveUserMetrics={retrieveUserMetrics} downloadExcel={downloadExcel} />
  );
};

export default UserMetricsContainer;
